import React from "react";
import moment from 'moment'
import { makeStyles, Grid, Paper, Grow, Box } from '@material-ui/core';
import "weather-icons/css/weather-icons.css";
const Api_Key = "c54167baed7f0d021f7b4cbfabf5ba5b";


const useStyles = makeStyles((theme) => ({

  widget: {
    width: '100%',
    display: "flex",
    justifyContent: "space-around",
    backgroundColor: "#fcfdfd",
    borderRadius: "9px",
    padding: "30px",
  },



  date: {
    fontSize: '14px',
    fontWeight: 'bold',
    color: 'rgba(0,0,0,0.5)',
  },

  city: {
    fontSize: '.9rem',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    paddingTop: '5px',
    color: 'rgba(0,0,0,0.7)',
    fontFamily: "Zen Dots,cursive",

  },
  cityName: {
    fontSize: '1.5rem',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    paddingTop: '5px',
    color: 'rgba(0,0,0,0.7)',
    fontFamily: "Zen Dots,cursive",
    [theme.breakpoints.down("md")]: {
      fontSize: '1rem',
    }
  },

  temp:
  {
    fontSize: '81px',
    color: 'rgba(0,0,0,0.9)',
    fontWeight: 100,
    [theme.breakpoints.down('sm')]: {
      fontSize: '20px',
    },
  },

  panel:
  {
    display: 'inline-block',
  },

  rightpanel:
  {
    position: 'absolute',
    float: 'right',
    top: 0,
    marginTop: '35px',
    paddingLeft: '10px',
  },
  img: {
    [theme.breakpoints.down("md")]: {
      width: "5rem",
      paddingTop: "0.5rem"
    }
  }

}))


export default function Wather({ Cityname, CountryName }) {


  const [icon, setweatherIcon] = React.useState({})
  const [status, setStatus] = React.useState(null)
  const [weather, setweather] = React.useState({
    city: undefined,
    country: undefined,
    icon: undefined,
    celsius: undefined,
    temp_max: null,
    temp_min: null,
    sunrise: null,

    description: "",
    error: false
  })



  React.useEffect(() => {
    if (Cityname) {

      const api_call = fetch(
        `http://api.openweathermap.org/data/2.5/weather?q=${Cityname.toString()},${'us'}&appid=${Api_Key}`
      ).then((res) => {

        return res.json()
      }).then(async (res) => {


        let response = await res

        setweather((prevState) => ({
          ...prevState,
          city: response.message === "city not found" || response.code == "404" || response == undefined ? undefined : `${response.name}, ${response.sys.country}`,
          country: response.message === "city not found" || response.code == "404" || response == undefined ? undefined : response.sys.country,
          celsius: response.message === "city not found" || response.code == "404" || response == undefined ? undefined : Math.floor(response.main.temp - 273.15),
          temp_max: response.message === "city not found" || response.code == "404" || response == undefined ? undefined : Math.floor(response.main.temp_max - 273.15),
          temp_min: response.message === "city not found" || response.code == "404" || response == undefined ? undefined : Math.floor(response.main.temp_min - 273.15),
          description: response.message === "city not found" || response.code == "404" || response == undefined ? undefined : response.weather[0].description,

        }))


        let status = response.sys.sunrise > response.dt || response.sys.sunset < response.dt ? get_WeatherIcon(weatherNightIcon, response.weather[0].id) : get_WeatherIcon(weatherIcon, response.weather[0].id)

        setStatus(status)
      })
        .catch((e) => {
          setweather({
            ...weather,
            error: true
          })
        })


    }

  }, [])





  const weatherIcon = {
    Thunderstorm: "wi-thunderstorm",
    Drizzle: "wi-sleet",
    Rain: "wi-storm-showers",
    Snow: "wi-snow",
    Atmosphere: "wi-fog",
    Clear: "wi-day-sunny",
    Clouds: "wi-day-fog"
  };


  const weatherNightIcon = {
    Thunderstorm: "wi-night-alt-snow-thunderstorm",
    Drizzle: "wi-night-sleet",
    Rain: "wi-night-alt-showers",
    Snow: "wi-night-alt-snow",
    Atmosphere: "wi-night-fog",
    Clear: "wi-night-clear",
    Clouds: "wi-night-fog"
  };


  const get_WeatherIcon = (icons, rangeId) => {


    switch (true) {
      case rangeId >= 200 && rangeId < 232:
        setweatherIcon({ icon: icons.Thunderstorm });
        break;
      case rangeId >= 300 && rangeId <= 321:
        setweatherIcon({ icon: icons.Drizzle });
        break;
      case rangeId >= 500 && rangeId <= 521:
        setweatherIcon({ icon: icons.Rain });
        break;
      case rangeId >= 600 && rangeId <= 622:
        setweatherIcon({ icon: icons.Snow });
        break;
      case rangeId >= 701 && rangeId <= 781:
        setweatherIcon({ icon: icons.Atmosphere });
        break;
      case rangeId === 800:
        setweatherIcon({ icon: icons.Clear });
        break;
      case rangeId >= 801 && rangeId <= 804:
        setweatherIcon({ icon: icons.Clouds });
        break;
      default:
        setweatherIcon({ icon: icons.Clouds });
    }
  }

  var date = moment().format('MMMM Do YYYY')

  const classes = useStyles();

  return (
    <Grid container mxWidth="md" className={classes.widget}>


      <Grid item xs={11} sm={6} md={6} className={classes.panel}>
        <div className={classes.date}>
          {date}
        </div>
        <br />
        <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center" }}>
          <img src="/media/weather.png" className={classes.img} alt="" width="160" />
          <span className={classes.cityName}>
            &nbsp;&nbsp;&nbsp;&nbsp;{Cityname ? Cityname : "not Found"}
          </span>
        </div>
      </Grid>
      <Grid item item xs={11} sm={6} md={4} className={classes.panel}>
        <div className={classes.temp}>
          <i className={`wi ${icon.icon}`} style={{ color: "yellow", fontSize: "4rem" }} /> &nbsp;
          {weather.celsius ? weather.celsius : ""}&deg;&nbsp;
          <span className={classes.city} style={{ color: "black", textAlign: "center" }}>{weather.temp_max ? weather.temp_max : ""}&deg;&nbsp;&nbsp;/</span>
          <span className={classes.city} style={{ color: "black", paddingLeft: "1rem" }}>{weather.temp_min ? weather.temp_min : ""}&deg;</span>
          <div className={classes.city}>&nbsp;&nbsp;&nbsp;&nbsp;{weather.description ? weather.description.charAt(0).toUpperCase() +
            weather.description.slice(1) : "not Found"}</div>
        </div>
      </Grid>


    </Grid>
  )
}


